<router-outlet></router-outlet>
<ngx-guided-tour skipText=""
                 nextText="Next"
                 doneText="Done"
                 topOfPageAdjustment="50"
                 minimalTourStepWidth="300"
                 [progressIndicatorLocation]="position"
                 >
</ngx-guided-tour>
